import { render, staticRenderFns } from "./review.vue?vue&type=template&id=749d8010&scoped=true&"
import script from "./review.vue?vue&type=script&lang=js&"
export * from "./review.vue?vue&type=script&lang=js&"
import style0 from "./review.vue?vue&type=style&index=0&lang=css&"
import style1 from "./review.vue?vue&type=style&index=1&id=749d8010&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749d8010",
  null
  
)

export default component.exports